/**
 * returns specified index namespaced to environment
 * @param {String} index
 * @returns {String} indexName
 */
export default function getAlgoliaIndex(index) {
  const env = window?.environment;
  if (env === 'dev') {
    return `staging_${index}`;
  }
  return `${env}_${index}`;
}